<style scoped>
 .v-text-field >>> .v-select__selection {
   font-size: 0.8em;
 }
 .v-text-field >>> label {
   font-size: 0.8em;
 }
 .v-text-field >>> button {
   font-size: 0.2em;
 }
</style>
<template>
  <div class="container-00">

    <div class="osc-block-00 osc-border-00 card-00">
      <div class="card-title-00">
        {{ parameter_group_title }} &nbsp;
        <v-btn x-small icon v-on:click="dump_formant_param()"><v-icon>mdi-text-box-outline</v-icon></v-btn>
      </div>

      <!-- --------------------- -->
      <div class="select-block-00">
        <div>
          <v-select
              v-model="formant_param.formantFilter"
              v-on:change="onUpdateParam('formantFilter', $event)"
              :background-color="v_select_background_color"
              :items="filter_items"
              item-text="text"
              item-value="id"
              label="FILTER"
              menu-props="auto, overflowY"
              outlined
              hide-details
              dense
          ></v-select>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  export default {
   name: 'Formant',
   props: ['parameter_group_title', 'label', 'filter_items', 'formantparam'],
   methods: {
     dump_formant_param: function() {
       const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       console.log(`[store:${this.label}]`, workingPatch.decoded[`${this.label}`], workingPatch.decoded)
       console.log(`[local:${this.label}]`, this.$data.formant_param)
     },
     onUpdateParam: function(key, val) {
       console.log(this.formant_param, key, val, this.$data)
       //const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       //const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       //console.log(this.label, workingPatch)
       this.$set(this.$data.formant_param, key, val)
       this.$store.commit('onEditOneEditPatch', {arr_idx: [key], value: Uint8Array.from([val])})

       // let PatchNumNameCard component to recognise params change
       this.$router.app.$children[0].updateParamIsSyncedApp()
     }
   },
   created: function() {
     console.log(`<CREATED> label=[${this.label}]`)
     Object.keys(this.formantparam).forEach( key => {
       this.$data.formant_param[key] = this.formantparam[key]
     })
   },
   computed: {
     testCount: {
       get () {
         return this.$store.getters.getTestCount()
       },
       set () {}
     }
   },
   data: () => ({
     v_select_background_color: '#fffef2',
     formant_param: {
       formantFilter: 0
     }
     //filter_item_value: 'LINK',
   })
 }
</script>
